import { useTranslation } from '@front10/utils';
import React from 'react';
import { Button } from '../../Button';

function Dot({ pageNumber, ...props }: Props) {
  const translate = useTranslation();
  return (
    <Button
      tabIndex={-1}
      variant="carouselDot"
      aria-label={`${translate('cmp-carousel-dot', 'Go to slide')} ${pageNumber + 1}`}
      sx={{
        borderRadius: '50%',
        transition: 'all 0.5s',
        boxShadow: 'unset',
        cursor: 'pointer',
        padding: '3px',
        marginRight: '16px',
        backgroundColor: 'colorBorders',
        '&:hover, .slick-active > &': {
          backgroundColor: 'colorPrimary'
        }
      }}
      {...props}
    />
  );
}

interface Props {
  pageNumber: number;
}

const memoizedDot = React.memo(Dot);

export { memoizedDot as Dot };
